/* React Higher Order Component which fetches course lock data for course where shortCourseId = props.shortCourseId. Lock data will refresh via poll and pass changes via props
    Child (InnerComponent) will only render once course data is successfully fetched.
    child will receive props: {
        editLock: PropTypes.object
        onToggleActivityLockPoll: PropTypes.func
    }

*/

import React from 'react';
import PropTypes from 'prop-types';

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const ReactUtil = require('../../util/ReactUtil');
import LoadingMainContent from '../loading/LoadingMainContent';

const propTypes = {
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    projectStoreState: PropTypes.shape({ shortCourseProject: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    documentVisible: PropTypes.bool.isRequired,
    hideLoadingIcon: PropTypes.bool,
};

const defaultProps = {
    hideLoadingIcon: false,
};

const POLL_ACTION_ID = 'course-lock-poll';

export default function withShortCourseLockPoll(WrappedComponent) {
    class WithShortCourseLockPoll extends React.Component {
        constructor(props) {
            super(props);

            let editLock = null;
            if (props.projectStoreState && 
                props.projectStoreState.shortCourseProject && 
                props.channelStoreState &&
                props.channelStoreState.channel) {
                editLock = ShortCourseStore.getStateShortCourse(props.shortCourseId,props.projectStoreState.shortCourseProject.id,props.channelStoreState.channel.id).editLock
            }
            this.state = {
                editLock,
                devDisablePolling: false,
                fatalError: null
            }

            this.refreshLockData = this.refreshLockData.bind(this);
            this.onTogglePolling = this.onTogglePolling.bind(this);
            this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
            const self = this;
            this.refreshLockData(true);
            this.updateLockInterval = window.setInterval(self.refreshLockData, 10000);
        }

        componentWillUnmount() {
            window.clearInterval(this.updateLockInterval);
            this.unsubscribes.forEach(u => u());
        }

        onShortCourseStoreChange(newState) {
            if (newState.action.id === POLL_ACTION_ID) {
                this.setState({
                    editLock: ShortCourseStore.getStateShortCourse(
                        this.props.shortCourseId,
                        this.props.projectStoreState.shortCourseProject.id,
                        this.props.channelStoreState.channel.id
                        ).editLock,
                });
            }
        }

        refreshLockData(init=false) {
            if (
                !init // ignore all other visibilty/poll disabled when fetching for the first time
                && (!this.props.documentVisible || this.state.devDisablePolling)
            ) {
                return;
            }

            const project = this.props.projectStoreState.shortCourseProject;
            const channel = this.props.channelStoreState.channel;
            if (!project || !channel || !PermissionsUtil.canViewActivities(channel.user_permissions, project.user_permissions)) {
                return;
            }

            ShortCourseActions.getEditLockStatus(
                POLL_ACTION_ID,
                {
                    shortCourseId: this.props.shortCourseId,
                    projectId: this.props.projectStoreState.shortCourseProject.id
                }
            );
        }

        onTogglePolling(pollBool) {
            this.setState({ devDisablePolling: pollBool });
        }

        render() {
            if (!this.state.editLock) { // wait until activity lock data is known before rendering children
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    editLock={this.state.editLock}
                    onToggleActivityLockPoll={this.onTogglePolling}
                />
            );
        }
    }

    WithShortCourseLockPoll.propTypes = propTypes;
    WithShortCourseLockPoll.defaultProps = defaultProps;
    WithShortCourseLockPoll.displayName = `WithShortCourseLockPoll(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithShortCourseLockPoll;
}
